import { configMerge } from './config-merge'
import './index.scss'
export default {
    name: 'form-generator',
    props: {
        model: {
            type: Object,
            default: () => { return {} }
        },
        formConfig: {
            type: Array,
            default: () => { return [] }
        },
        labelWidth: {
            type: String,
            default: "80px"
        }
    },
    methods: {
        validate() {
            return new Promise(async (res, rej) => {
                this.$refs.form.validate((valid) => {
                    res(valid)
                })
            })
        }
    },
    render(h) {
        const getAttr = (key) => {
            return {
                on: {
                    change: (item) => {
                        let params = {}
                        params[key] = item
                        this.$emit('change', params)
                    }
                }
            }
        }
        let formitem = []
        let config = {
            input: (item) => {
                return (<el-input style="width:192px" v-model={this.model[item.key]} placeholder="请输入" {...getAttr(item.key)}></el-input>)
            },
            radio: (item) => {
                let group = []
                for (let listitem of item.list) {
                    group.push(
                        (<el-radio-button label={listitem.value}>{listitem.text}</el-radio-button>)
                    )
                }
                return (
                    <el-radio-group class="wz-form-radio-group" v-model={this.model[item.key]} placeholder="请选择" size="small" {...getAttr(item.key)}>
                        {group}
                    </el-radio-group>
                )
            },
            select: (item) => {
                let group = []
                if (item.list && item.list.length) {
                    for (let listitem of item.list) {
                        group.push(
                            (<el-option label={listitem.text} value={listitem.value}></el-option>)
                        )
                    }
                }
                return (
                    <el-select v-model={this.model[item.key]} placeholder="请选择" {...getAttr(item.key)}>
                        {group}
                    </el-select>
                )
            },
            date: (item) => {
                return (<el-date-picker format='yyyy-MM-dd' value-format='yyyy-MM-dd' v-model={this.model[item.key]} placeholder="请选择" {...getAttr(item.key)}></el-date-picker>)
            },
            "date-range": (item) => {
                return (<el-date-picker
                    {...getAttr(item.key)}
                    v-model={this.model[item.key]}
                    type="daterange"
                    format='yyyy-MM-dd'
                    value-format='yyyy-MM-dd'
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期">
                </el-date-picker>)
            },
        }
        let formConfig = configMerge(this.formConfig)
        for (let item of formConfig) {
            formitem.push(
                (
                    <el-form-item
                        label={item.label}
                        class={["wz-search-filter-item"]}
                    >
                        {config[item.type](item)}
                    </el-form-item>
                )
            )
        }
        return (
            <div>
                <el-form
                    class="wz-search-filter-generate"
                    ref="form"
                    props={{
                        model: this.model,
                    }}
                    size="small"
                    submit={{ native: { prevent: true } }}>
                    {formitem}
                    {this.$slots.default[0]}
                </el-form>
            </div>
        )
    }
}
